import * as ACTION from './constants';
import apiService from './../apiService';
import { processApiRequest } from './../../../Common/saga';

export function* getDeliveryNoteReturns(action) {
    yield processApiRequest(ACTION.GET_RETURNS, () => apiService.getList(action.payload), action.payload);
}
